export enum BuildType {
    dev,
    staging,
    prod
}